export const BRAND_NAME = 'Scheduler';
export const PRODUCT_NAME = 'Team scheduling';

export function Brand({ subtitle = PRODUCT_NAME, compact = false, inverse = false }) {
  return (
    <div className={`brand-lockup${compact ? ' brand-compact' : ''}${inverse ? ' brand-inverse' : ''}`}>
      <img className="brand-mark" src="/logo-icon.svg" alt={compact ? BRAND_NAME : ''} />
      {!compact && <div className="brand-copy"><strong>{BRAND_NAME}</strong>{subtitle && <span>{subtitle}</span>}</div>}
    </div>
  );
}
